import { render, staticRenderFns } from "./SButtonLogout.vue?vue&type=template&id=3e6ac412"
import script from "./sButtonLogout.ts?vue&type=script&lang=ts&external"
export * from "./sButtonLogout.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports